import packingRequest from '../request/packing'

const apiRequest = packingRequest()

export const getShippingRules = async (payload) => {
    const {data} = await apiRequest({
        url: `/packing/shipping/rules/search`,
        method: 'POST',
        data: payload
    })

    return data
}

export const getPlatform = async () => {
    const {data} = await apiRequest({
        url: `/packing/platforms`,
        method: 'GET'
    })

    return data
}

export const changeStatus = async (id, payload) => {
    const {data} = await apiRequest({
        url: `/packing/shipping/rules/${id}`,
        method: 'PUT',
        data: payload
    })

    return data
}